import React from 'react'
import { Layout, Button } from 'antd'
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons'
import './navbar.css'

const { Header } = Layout

interface NavbarProps {
  onOpenMobileNav?: () => void
}

export default function Navbar({ onOpenMobileNav }: NavbarProps) {
  const handleLogout = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('token')
    window.location.href = 'https://trendy-auth.titamedia.xyz/login'
  }

  return (
    <Header className="app-navbar">
      <div className="app-navbar__left">
        <Button
          className="app-navbar__menu-btn"
          type="text"
          icon={<MenuOutlined />}
          aria-label="Abrir menú de navegación"
          onClick={onOpenMobileNav}
        />
        <img
          src={`${process.env.PUBLIC_URL}/logo_trendy_rosado.png`}
          alt="Logo"
          className="app-navbar__logo"
        />
      </div>
      <Button
        className="app-navbar__logout"
        type="text"
        icon={<LogoutOutlined />}
        onClick={handleLogout}
      >
        <span className="app-navbar__logout-label">Cerrar sesión</span>
      </Button>
    </Header>
  )
}
